import React, { useState, useEffect } from "react";
import { Button, Modal, Skeleton, Input } from "antd";

const CampaignCommentComponent = ({
  t,
  isSuperUser,
  comment,
  commentLoading,
  commentModalVisible,
  currentComment,
  onEditClick,
  onModalCancel,
  onModalOk,
}) => {
  const [localComment, setLocalComment] = useState(currentComment || comment || '');

  useEffect(() => {
    if (commentModalVisible) {
      setLocalComment(currentComment || comment || '');
    }
  }, [commentModalVisible, currentComment, comment]);

  if (!isSuperUser) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
      <p className="campaign-comment" style={{ marginRight: '8px', marginBottom: 0 }}>
        <Button
          icon="edit"
          type="link"
          onClick={onEditClick}
          style={{ marginRight: '8px', padding: 0 }}
        />
        {t('Comment')}:
      </p>
      {commentLoading ? (
        <Skeleton active paragraph={{ rows: 1, width: '100px' }} title={false} />
      ) : (
        <p className="comment-text">{comment}</p>
      )}
      <Modal
        style={{ padding: '20px' }}
        title={t("Edit comment")}
        visible={commentModalVisible}
        onCancel={onModalCancel}
        onOk={() => onModalOk(localComment)}
        okText={t("Edit")}
        cancelText={t("Close")}
        confirmLoading={commentLoading}
      >
        <Input.TextArea
          maxLength={240}
          style={{ width: '95%', margin: 10 }}
          value={localComment}
          onChange={e => setLocalComment(e.target.value)}
          placeholder={t("Enter your comment")}
          rows={4}
          disabled={commentLoading}
        />
      </Modal>
    </div>
  );
};

export default React.memo(CampaignCommentComponent);